



























import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import InlineSpinner from "@/lib/components/InlineSpinner.vue";

import dataStore from "@/store";
import AuthenticatedUserProvider from "@/modules/account/authenticated-user-provider.service";

import PlushieStore from "../store";
import Plushie from "../plushie.model";
import OrderInformation from "../order-information.model";

@Component({
  components: {
    InlineSpinner,
  },
})
export default class PlushieInfo extends Vue {
  @Prop({ required: true })
  public readonly plushieId!: string;

  @Inject("AuthenticatedUserProvider")
  private fUserProvider!: AuthenticatedUserProvider;

  private fIsLoading = true;

  private fPlushieDataStore: PlushieStore;

  get isLoading(): boolean {
    return this.fIsLoading;
  }

  get plushie(): Plushie | undefined {
    return this.fPlushieDataStore.getPlushieById(this.plushieId);
  }

  get orderInformation(): OrderInformation | undefined {
    return this.fPlushieDataStore.getOrderInformationByPlushieId(
      this.plushieId
    );
  }

  get upgrades(): string {
    if (!this.plushie) {
      return "";
    }

    const ids = this.fPlushieDataStore.getPlushieUpgradesByPlushieId(
      this.plushie.id
    );

    const upgrades: string[] = [];

    ids.forEach((id) => {
      const upgrade = this.fPlushieDataStore.getUpgradeById(id);

      if (!upgrade) {
        return;
      }

      upgrades.push(upgrade.name);
    });

    return upgrades.join(", ");
  }

  constructor() {
    super();

    this.fPlushieDataStore = getModule(PlushieStore, dataStore);
  }

  private async getPlushieData(plushieId: string): Promise<void> {
    await Promise.all([
      this.fPlushieDataStore.loadPlushieById({ id: plushieId }),
      this.fPlushieDataStore.loadUpgrades(),
      this.fPlushieDataStore.loadPlushieUpgradesByPlushieId({
        plushieId: plushieId,
      }),
      this.fPlushieDataStore.loadOrderInformationByPlushieId(this.plushieId),
    ]);
  }

  @Watch("plushieId", { immediate: true })
  private async _onPlushieIdChange() {
    if (!this.plushieId) {
      return;
    }

    this.fIsLoading = true;

    try {
      await this.getPlushieData(this.plushieId);
    } finally {
      this.fIsLoading = false;
    }
  }
}
